import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './LinkButton.module.scss';
type Props = {
    link: string;
    label: string;
    external?: boolean;
    newPage?: boolean;
};

const LinkButton = ({ link, label, external, newPage }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const { search } = useLocation();
    if (external) {
        return (
            <a
                href={link}
                className={styles.element}
                target={newPage ? '_blank' : undefined}
                rel={newPage ? 'noopener noreferrer' : undefined}
            >
                {txt(label)}
            </a>
        );
    }
    return (
        <NavLink className={styles.element} to={`${link}${search}`}>
            {txt(label)}
        </NavLink>
    );
};

export default LinkButton;
